module.exports = __webpack_public_path__ + "static/media/Gourmet Chef.712a1146.jpg";